import type { MappingFieldDescriptor } from "../services/widgetService";

export type IndexDateFieldOption = {
  path: string;
  label: string;
  type: string;
  aggregatable: boolean;
};

export function isLikelyDateMappingField(field: MappingFieldDescriptor): boolean {
  return field.type === "date" || field.path.toLowerCase().includes("date");
}

export function dateFieldOptionsFromMapping(
  fields: MappingFieldDescriptor[] | undefined
): IndexDateFieldOption[] {
  return (fields ?? [])
    .filter(isLikelyDateMappingField)
    .map((field) => ({
      path: field.path,
      label: `${field.path} (${field.type})`,
      type: field.type,
      aggregatable: field.aggregatable,
    }));
}

export function resolveIndexDateFieldOption(
  value: string | undefined,
  options: IndexDateFieldOption[]
): IndexDateFieldOption | null {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return null;
  return (
    options.find((option) => option.path === trimmed) ?? {
      path: trimmed,
      label: trimmed,
      type: "date",
      aggregatable: false,
    }
  );
}
